export enum ActionTypes {
  GET_ALL_DEAL_STATS = '[GET_ALL_DEAL_STATS] Get all deal stats',
  GET_ALL_DEAL_STATS_SUCCESS = '[GET_ALL_DEAL_STATS] Get all deal stats success',
  GET_ALL_DEAL_STATS_FAILURE = '[GET_ALL_DEAL_STATS] Get all deal stats failure',
  CLEAR_ALL_DEAL_STATS = '[GET_ALL_DEAL_STATS] Clear all deal stats',
}
